<template>
  <div class="layout-wrapper">
    <BaseStepper
      v-if="isShowStepperBase"
      class="mb-1"
      :key="isQuestionSteps"
      :steps="isQuestionSteps ? questionSteps : applicationSteps"
    />
    <div class="alert-wrapper mx-3 mx-xl-0">
      <BaseAlert
        color="var(--orange-100)"
        class="quote-expired-message"
        v-if="isExpired"
      >
        <div class="d-flex flex-no-wrap error-message">
          <div class="mr-3">
            <v-icon color="var(--orange-500)">mdi-alert</v-icon>
          </div>
          <div>
            <span class="font-weight-bold">Sorry!</span> This quote has expired.
            Please check all the details below are accurate and submit a new
            quote.
          </div>
        </div>
      </BaseAlert>
      <QuoteErrorAlert :isQuotationStage="isQuestionSteps" />
    </div>

    <div
      class="b2b-tl-journey__container white rounded-lg elevation-3 mx-3 mt-3 mx-xl-0"
    >
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/common/eventbus.js";
import { handleValidationError } from "@/common/utils";
import { ROUTE_NAME } from "@/constants/route.constants";
import { QUESTIONS_MODULE } from "@/store/types/module-types";

import BaseStepper from "@/components/BaseComponents/BaseStepper.vue";
export default {
  name: "TenantsLiabilityLayout",
  components: {
    BaseStepper,
    BaseAlert: () => import("@/components/BaseComponents/BaseAlert.vue"),
    QuoteErrorAlert: () => import("@/components/QuoteErrorAlert.vue"),
  },
  data() {
    return {
      questionSteps: [
        {
          stepNumber: 1,
          label: "Your details",
          routeName: ROUTE_NAME.TENANTS_LIABILITY.B2B.YOUR_DETAILS,
        },
        {
          stepNumber: 2,
          label: "Property details",
          routeName: ROUTE_NAME.TENANTS_LIABILITY.B2B.PROPERTY_DETAILS,
        },
        {
          stepNumber: 3,
          label: "Your quote",
          routeName: ROUTE_NAME.TENANTS_LIABILITY.B2B.QUOTATION_RESULT,
        },
      ],
      applicationSteps: [
        {
          stepNumber: 4,
          label: "Your application ",
          routeName: ROUTE_NAME.TENANTS_LIABILITY.B2B.APPLICATION,
        },
        {
          stepNumber: 5,
          label: "Payment",
          routeName: ROUTE_NAME.TENANTS_LIABILITY.B2B.PAYMENT,
        },
        {
          stepNumber: 6,
          label: "Complete",
          routeName: ROUTE_NAME.TENANTS_LIABILITY.B2B.COMPLETE,
        },
      ],
    };
  },
  created() {
    // Listen for validation errors globally
    EventBus.$on("validation-error", handleValidationError);
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, [
      "isExpired",
      "isQuestionSteps",
      "isQuoteResultPage",
    ]),
    currentRouteName() {
      return this.$route.name;
    },
    isShowStepperBase() {
      return ![ROUTE_NAME.TENANTS_LIABILITY.B2B.COMPLETE].includes(
        this.currentRouteName
      );
    },
  },
};
</script>

<style lang="scss">
.layout-wrapper {
  max-width: 1080px;
}
.b2b-tl-journey__container {
  padding: 24px 16px 40px 16px !important;
  margin-bottom: 40px;
  max-width: 1080px;
  .radio-group__wrapper {
    max-width: 400px;
  }
}

@media screen and (min-width: $grid-breakpoints-sm) {
  .b2b-tl-journey__container {
    padding: 40px !important;
  }
}

@media screen and (min-width: $grid-breakpoints-lg) {
  .b2b-tl-journey__container {
    padding: 40px 40px 80px 40px !important;
    margin-bottom: 80px !important;
  }
}
</style>
